$(function () {
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function closeMenu() {
        var toggle = $("#menu-toggle");

        toggle.attr("aria-expanded", "false");

        toggle.siblings(".nav-menu").fadeOut(prefersReducedMotion.matches ? 0 : 250, function () {
            closeAllSubMenus($(this));
        });
    }

    function closeAllSubMenus(menu) {
        menu.find(".sub-menu-toggle").attr("aria-expanded", "false");
        menu.find(".nav-sub-menu").hide();
    }

    $("#menu-toggle").on("click", function (e) {
        var toggle = $(this);

        e.stopPropagation();

        toggle.attr("aria-expanded", function (_i, attr) { return attr === "true" ? "false" : "true" });

        toggle.siblings(".nav-menu").fadeToggle(prefersReducedMotion.matches ? 0 : 250, function () {
            closeAllSubMenus($(this));
        });
    });

    $("#menu").on("click", function (e) {
        e.stopPropagation();
    });

    $("#menu").on("click", ".sub-menu-toggle", function (e) {
        var toggle = $(this);

        toggle.attr("aria-expanded", function (_i, attr) { return attr == "true" ? "false" : "true" });
        toggle.siblings(".nav-sub-menu").slideToggle(prefersReducedMotion.matches ? 0 : 250);

        if (window.innerWidth >= 720) {
            var otherToggles = $("#menu .sub-menu-toggle[aria-expanded=true]").not(toggle);
            otherToggles.attr("aria-expanded", "false");
            otherToggles.siblings(".nav-sub-menu").slideUp(prefersReducedMotion.matches ? 0 : 250);
        }

        e.preventDefault();

        return false;
    });

    $(".print-button").show();

    $(".print-button").on("click", "a, button", function (e) {
        window.print();

        return false;
    });

    $(document).on("click", function () {
        closeMenu();
    });

    $(".main-nav").on("focusout", function (e) {
        var nav = $(this);

        setTimeout(function () {
            if (document.activeElement !== document.body && nav.has($(document.activeElement)).length == 0) {
                closeMenu();
            }
        }, 0);
    });
});
